import { EmployeeKpiTable } from "../dashboard/EmployeeKpiTable";
import { EmployeeValueChartSection } from "./employees/components/EmployeeValueChartSection";
import { useEmployeesAnalytics } from "./employees/hooks/useEmployeesAnalytics";
import { ServicesLoadingState } from "./services/components/ServicesLoadingState";

interface EmployeesTabProps {
  from: string;
  to: string;
  basis: "accrual" | "cash";
}

export function EmployeesTab({ from, to, basis }: EmployeesTabProps) {
  const { rows, topRows, isLoading } = useEmployeesAnalytics({ from, to, basis });

  if (isLoading) return <ServicesLoadingState />;

  return (
    <div>
      <EmployeeValueChartSection rows={topRows} />
      <EmployeeKpiTable rows={rows} from={from} to={to} basis={basis} />
    </div>
  );
}
